export function DeviceStatus(props: { status: string }) {
  const statusDef = {
    color: "red",
    bg: "red",
    statusColor: "red",
    text: "unknown",
  };

  switch (props.status) {
    case "yes":
    case "online":
      statusDef.color = "text-green-700 dark:text-green-200";
      statusDef.bg = "bg-green-100 dark:bg-green-800/30";
      statusDef.text = "Online";
      statusDef.statusColor = "fill-green-500 dark:fill-green-300";
      break;
    case "no":
    case "offline":
      statusDef.color = "text-orange-700 dark:text-orange-200";
      statusDef.bg = "bg-orange-100 dark:bg-orange-800/30";
      statusDef.statusColor = "fill-orange-500 dark:fill-orange-300";
      statusDef.text = "Offline";
      break;

    default:
      statusDef.color = "text-gray-700";
      statusDef.bg = "bg-gray-100";
      statusDef.statusColor = "fill-gray-500";
      statusDef.text = props.status === "N/A" ? "Unknown" : props.status.toString().toUpperCase();
      break;
  }

  return (
    <div className={`inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium  ${statusDef.color} ${statusDef.bg}`}>
      <svg className={`h-1.5 w-1.5 ${statusDef.statusColor}`} viewBox="0 0 6 6" aria-hidden="true">
        <circle cx={3} cy={3} r={3} />
      </svg>
      {statusDef.text}
    </div>
  );
}
